import { render, staticRenderFns } from "./InterNav.vue?vue&type=template&id=56b772fb&scoped=true&"
import script from "./InterNav.vue?vue&type=script&lang=js&"
export * from "./InterNav.vue?vue&type=script&lang=js&"
import style0 from "./InterNav.vue?vue&type=style&index=0&id=56b772fb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b772fb",
  null
  
)

export default component.exports